'use client';

import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import type { FieldPath, FieldValues } from 'react-hook-form';
import Field from '@/form/ActionForm/Field';
import type { FieldAsPropType, FieldProps } from '@/form/ActionForm/Field';
function RequiredField(props) {
  const $ = _c(3);
  const t0 = `${props.title}*`;
  let t1;
  if ($[0] !== props || $[1] !== t0) {
    t1 = <Field {...props} label={t0} required={true} />;
    $[0] = props;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function WithFormValues<TFormValues extends FieldValues>() {
  return RequiredField as <TField extends FieldPath<TFormValues>, TInput extends FieldAsPropType = 'input'>(props: FieldProps<TFormValues, TField, TInput>) => JSX.Element;
}
export default RequiredField;